import { Component, OnInit, OnDestroy, NgZone, Input } from '@angular/core';

import { Subscription } from 'rxjs';

import {
    EquipmentService,
    Model,
    PoweredBy,
    Equipment,
    EquipmentForModelAndPoweredBy,
    DataArray,
    ToastrService
} from './../../../../shared/index';

@Component({
    selector: 'poweredby-entity',
    templateUrl: './poweredby-entity.html',
    standalone: false
})

export class PoweredByEntityComponent implements OnInit, OnDestroy {
    @Input('poweredby') poweredby: PoweredBy = new PoweredBy();
    @Input('model') model: Model = new Model();
    @Input('simplified') simplified = false;
    @Input('full') full = false;
    @Input('listOnly') listOnly = false;
    @Input('live') live = true;
    @Input('isDocumentPage') isDocumentPage: boolean;
    public equipmentVisible = false
    public equipment: DataArray<Equipment> = new DataArray<Equipment>(1);

    private subscriptions: Subscription[] = [];

    constructor(
        private _equipmentService: EquipmentService,
        private _ngZone: NgZone,
        private _toastrService: ToastrService
    ) {
        this.subscriptions.push(this._equipmentService.beginRecieve.subscribe((info: any) => {
            this._ngZone.run(() => {
                if (info.ModelId == this.model.Id && info.PoweredById == this.poweredby.Id) {
                    this.equipment.init();
                }
            });
        }));

        this.subscriptions.push(this._equipmentService.equipmentForPoweredByAndModelChange.subscribe((info: EquipmentForModelAndPoweredBy) => {
            this._ngZone.run(() => {
                if (info.ModelId == this.model.Id && info.PoweredById == this.poweredby.Id) {
                    this.equipment = new DataArray<Equipment>(1);
                    for (const equipment of info.Equipment) {
                        this.equipment.update(equipment, true);
                    }
                }
            });
        }));
        this.subscriptions.push(this._equipmentService.equipmentChange.subscribe((info: Equipment) => {
            this._ngZone.run(() => {
                if (info.ModelId == this.model.Id && info.PoweredById == this.poweredby.Id) {
                    this.equipment.update(info, true);
                }
            });
        }));
    }
    public showEquipment(): void {
        this.equipmentVisible = !this.equipmentVisible;
    }
    public addEquipment(): void {
        if (Number(localStorage.getItem('Lock')) == 1) {
            this._toastrService.displayToastrMessage('error', localStorage.getItem('Msg'), 'Environment Status!');
            return;
        }
        const equip: Equipment = new Equipment();
        equip.PoweredById = this.poweredby.Id;
        equip.ModelId = this.model.Id;
        this._equipmentService.manipulate(equip);
    }

    ngOnInit(): void {
        if (this.live) {
            this._equipmentService.getEquipmentForModelAndPoweredBy(this.model.Id, this.poweredby.Id);
        } else {
            this._equipmentService.GetEquipmentForModelAndPoweredByStaging(this.model.Id, this.poweredby.Id);

        }
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}
